import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import CategoriesPage from "../pages/categories/page";
import GuidesPage from "../pages/guides/page";
import ShippingPage from "../pages/shipping/page";
import ReviewsPage from "../pages/reviews/page";
import CouponsPage from "../pages/coupons/page";
import SafetyPage from "../pages/safety/page";
import ComparisonsPage from "../pages/comparisons/page";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import DisclaimerPage from "../pages/disclaimer/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";
import ProductsPage from "../pages/products/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/categories",
    element: <CategoriesPage />,
  },
  {
    path: "/guides",
    element: <GuidesPage />,
  },
  {
    path: "/shipping",
    element: <ShippingPage />,
  },
  {
    path: "/reviews",
    element: <ReviewsPage />,
  },
  {
    path: "/coupons",
    element: <CouponsPage />,
  },
  {
    path: "/safety",
    element: <SafetyPage />,
  },
  {
    path: "/comparisons",
    element: <ComparisonsPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/disclaimer",
    element: <DisclaimerPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;